<script>
  import { push } from "svelte-spa-router"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../../Shared/footer.svelte"
  import notify from "../../../../../Script/notify"
  import bulkUploadOperations, { updateLocalStorage } from "../../Stores/uploadFlow"
  import { loadJs } from "../../../../../Script/loadLibrary"
  import { flatenObject, unflattenObject } from "../../../../../Script/flatenObject"
  import { fetchSelectedDocumentTemp, fetchFileTemplate, checkBulkTemplate, sendXlFile, capitalizeArrayEntries, lowerCaseArrEntries, createNewBulkSessionTest } from "../../Script/bulkUpload"
  import Progress from "./Component/progress.svelte"
  import Table from "../../../../../Shared/TableWithoutApi/index.svelte"
  import List from "./Component/list.svelte"
  import LoadingScreen from "../../../SinglePublish/Components/loadingScreen.svelte"
  import ConfirmationModal from "../../Shared/confirmationModal.svelte"
  import MetaPreviewModal from "./Component/metaPreviewModal.svelte"
  import Options from "./Component/options.svelte"
  // import Dropdown from "../GenerateFile/Components/fileTypeDropdown.svelte"

  /**
   * @type {boolean} toggling the state of the button to disable or not
   */
  // let disableUploadBtn = true
  /**
   * @type {File} the file to be uploaded
   */
  let files
  // /**
  //  * @type {String} the name of the uploaded excel file
  //  */
  // let filename
  /**
   * @type {Number} the size of the uploaded excel file
   */
  let fileSize = 0
  /**
   * @type {RegExp} regex for the html entities
   */
  const htmlEntityRegex = /&[#A-Za-z0-9]+;/g
  /**
   * @type {RegExp} regex for validating date
   */
  const dateRegex = /^[0-9-/]+$/
  /**
   * @type {RegExp} regex pattern for validating the email address
   */
  const emailAddressPattern = /^[A-Z0-9.!#$%&'+/=?^_`{|}~-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+){1,}$/i
  /**
   * @type {RegExp} regex pattern for validating the json value
   */
  const allowedCharsRegex = /^[A-Za-z0-9\s-()+&.:]+$/
  /**
   * @type {Boolean} whether the invalid cells found or not in the uploaded file
   */
  let isInvalidCellsFound = false
  /**
   * @type {Boolean} whether the user selected to upload files or not
   */
  let isUserSelectedUploadFiles = false
  /**
   * @type {String} bulk template ID
   */
  // let bulkID
  /**
   * @type {boolean} whether to disable next btn or not
   */
  let disableNextBtn = true

  /**
   * @type {boolean} whether to indicate the dynamic header is found
   */
  let isDynamic = false
  /**
   * @type {Array<String>} list of uploaded file names
   */
  let uploadFileList = []

  /**
   * @type {boolean} showProgress - Flag to determine if the progress indicator should be shown.
   * Default value is false.
   */
  let showProgress = false
  /**
   * @type {number} width - The width of the progress bar or indicator.
   * Default value is 0, and it's updated based on the progress of operations.
   */
  let width = 0
  /**
   * @type {Array} SpreadSheet data stored.
   */
  let jsonData = []

  /**
   * @typedef {Object} session - represents the individual session values
   * @type {Object}
   * represents the individual session values
   *
   * @property {String} name - name of the current session
   * @property {String} title - title of the document
   * @property {Date} expiry - represents the expiry date of the document
   */
  let session = {}

  /**
   * @typedef {Object} notificationMinChar
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationMinChar}
   */
  let notificationMinChar = {
    close() {},
  }
  /**
   * @typedef {Object} notificationSplChar
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationSplChar}
   */
  let notificationSplChar = {
    close() {},
  }
  /**
   * @typedef {Object} notificationName
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationName}
   */
  let notificationName = {
    close() {},
  }
  /**
   * @type {notificationName}
   */
  let notificationInvalidFile = {
    close() {},
  }
  /**
   * @typedef {Object} notificationMaxChar
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationName}
   */
  let notificationMaxChar = {
    close() {},
  }

  let timer
  let showExpiryConfirmationModel = false
  let showMetaConfirmationModel = false
  let dateConfirmed = false
  let metaConfirmed = false
  let isExpiryGiven = false
  let showLoading = false

  let showMultipleSheetConfirmation = false

  let worksheetName = ""
  let showDownloadSpreadSheet = false

  let showOptionsModal = false

  let isEmailFound = false

  let tempCcList = []

  let ccList = []

  // let ccGivenEmail = ""

  // const addCcEmail = () => {
  //   ccGivenEmail = ccGivenEmail.trim()
  //   if (ccGivenEmail && emailAddressPattern.test(ccGivenEmail)) {
  //     let isDuplicate = ccEmailList.find((email) => email === ccGivenEmail)
  //     if (!isDuplicate) {
  //       ccEmailList = [ccGivenEmail, ...ccEmailList]
  //     }
  //     ccGivenEmail = ""
  //   } else if (ccGivenEmail.trim()) {
  //     const info = "PAGE: Start Bulk Upload\nEVENT: Adding CC Email"
  //     notify.danger("Enter a valid CC email address", info)
  //   }
  // }

  /**
   * Function for processing the uploaded file
   * @param {File} file - the uploaded file
   */
  const checkFile = async (e) => {
    try {
      notificationInvalidFile.close()
      // checking whether the file present or not
      session.title = ""
      // ccGivenEmail = ""
      // ccEmailList = []
      jsonData = []

      dateConfirmed = false
      showExpiryConfirmationModel = false
      width = 0
      disableNextBtn = true
      isExpiryGiven = false

      const MAX_FILE_SIZE = 2 * 1024 * 1024

      let testFileSize = !files ? e.target.files[0].size : files.size

      if (testFileSize > MAX_FILE_SIZE) throw "Maximum File size exceeded"

      showProgress = true

      if (!files) files = e.target.files[0]

      // Validating the file extension as xlsx
      let validFile = await loadFile(files)

      width = 10
      let filename = validFile.name.slice(0, 24)

      let validFileName = validFile.name.slice(0, 27)

      console.log({ validFileName, filename })

      let fileNameRegex = /[A-F\d]{24}[0-1]{2}-/i

      // console.log(validFileName, "validFileName")

      if (!fileNameRegex.test(validFileName)) throw "The uploaded file name does not match the original file name. Renaming the downloaded sheet is not allowed. Please upload the file with its original name."

      // assigning the file size to Kb
      fileSize = Math.round(validFile.size / 1024)

      // let bulkData = await checkBulkTemplate(filename)
      // bulkID = bulkData.bulk.id
      width = 20

      $bulkUploadOperations.invalidObj = {}

      // loading the exceljs library
      await loadJs("ExcelJS", "assets/lib/exceljs.min.js")
      width = 30

      let workbook
      let worksheet

      try {
        // processing the uploaded worksheet
        workbook = await processExcel(validFile)
        worksheet = workbook.getWorksheet(worksheetName)
      } catch (error) {
        if (error == "Multiple Sheets not allowed") {
          showMultipleSheetConfirmation = true
          return
        } else {
          console.error(error)
          worksheetName = ""
          throw error
        }
      }

      worksheetName = ""

      // get the rowCount of the worksheet
      const rowCount = worksheet.rowCount
      width = 40

      // if the rowCount equals to 1 it indicates there is no relative data in excel file
      if (rowCount == 1) throw "The uploaded spreadsheet file is empty."
      width = 50

      const firstRow = worksheet.getRow(1)

      firstRow.eachCell((cell) => {
        if (cell.value === "Expiry (Optional)") cell.value = "Expiry"
        if (cell.value === "Filename (with Filetype eg: .jpg, .jpeg, .png)") cell.value = "Filename"
        if (cell.value.endsWith(" (Filename with Filetype eg: .jpg, .jpeg, .png)")) cell.value = cell.value.replace(" (Filename with Filetype eg: .jpg, .jpeg, .png)", "")
      })

      // console.log(firstRow.values)

      // const buffer = await workbook.xlsx.writeBuffer()

      // files = new File([buffer], files.name, {
      //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      // })

      let row = firstRow.values
      row.shift()
      width = 60

      let dynamicSet = []

      let expiryIndex = row.indexOf("Expiry") + 1
      width = 70

      // console.log(row, "row")

      if (!row.includes("Expiry")) throw "The header row in the spreadsheet / templates has been modified after download, which is not allowed."
      width = 80

      // console.log(row, "row")

      if (expiryIndex != row.length) {
        dynamicSet = lowerCaseArrEntries(row.toString().split("Expiry,")[1].split(","))
      }

      let documentData = await fetchSelectedDocumentTemp(filename)

      let sessionName = validFile.name.replace(".xlsx", "")

      let generateFile = Boolean(Number(sessionName.slice(24, 25)))
      let sendEmail = Boolean(Number(sessionName.slice(25, 26)))

      if (generateFile) {
        uploadFileList = worksheet.getColumn(1).values
        uploadFileList = uploadFileList.slice(2)
      }

      let layersWithDynamicImg = []
      if (documentData) {
        if (generateFile) {
          if (!documentData.file) throw "We couldn't find the file template associated with the document template."
          // layersWithDynamicImg = await fetchFileTemplate(documentData.file)
          let dataFromFile = await fetchFileTemplate(documentData.file)

          let layers = JSON.parse(dataFromFile.layers)

          if (!layers.length) throw "Please add at least one layer in the respective file template."

          let isReceiverNameFound = Boolean(layers.filter((item) => item.attribute == "receiver_name").length)

          if (!isReceiverNameFound) throw 'The layer named "receiver_name" is missing, and it is mandatory. Please add the "receiver_name" layer in the respective file template.'

          layersWithDynamicImg = processFileData(layers)
        }
        if (sendEmail) {
          if (!documentData.email) throw "We couldn't find the email template associated with the document template."
          isEmailFound = true
        }
      }
      width = 90

      let options = {}
      options.metadata = JSON.parse(documentData.metadata)
      options.layers = layersWithDynamicImg

      let generatedHeader = generateHeader(options, generateFile, sendEmail)
      // row = row.map((row) => row.replace("(filename)", ""))

      // console.log(generatedHeader, "generatedHeader")

      let validateExcelBasedOnHeader = areArraysEqual(row, generatedHeader)

      if (!validateExcelBasedOnHeader) throw "The header row in the spreadsheet / templates has been modified after download, which is not allowed."

      if (!row.length) throw "The header row in the spreadsheet / templates has been modified after download, which is not allowed."
      else {
        for (let i = 1; i < row.length; i++) {
          if (!row[i]) throw "The header row in the spreadsheet / templates has been modified after download, which is not allowed."
        }
      }

      // let jsonData = []

      try {
        // processing the worksheet and converting it into json
        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
          const isRowEmpty = row.values.every((cellValue) => cellValue.toString().trim() === null || cellValue.toString().trim() === "")

          if (rowNumber !== 1 && !isRowEmpty) {
            let cellCount = worksheet.getRow(1).cellCount
            let currentRow = worksheet.getRow(rowNumber)
            let currentRowValues = currentRow.values
            currentRowValues.shift()

            let ArrayForFillingEmptySpaces = Array(cellCount).fill("")
            for (let i = 0; i < cellCount; i++) {
              if (currentRowValues[i]) ArrayForFillingEmptySpaces[i] = currentRowValues[i]
            }

            currentRow.values = [...ArrayForFillingEmptySpaces]

            const rowData = {}

            currentRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
              const modifiedString = cell.address.replace(/[A-Za-z]\d+/g, (match) => {
                return `${match[0]}1`
              })

              let key = worksheet.getCell(modifiedString).value

              if (key) {
                key = firstLetterToLower(key)

                isDynamic = dynamicSet.includes(key) ? true : false

                validateRowBasedOnKey(cell, key)
                // validateRowBasedOnKey(value, rowNumber, cell.address, key)

                if (key === "expiry") {
                  cell.value = rowData["expireOn"] = cell.value ? convertToISOString(cell.value, cell.type) : ""
                } else {
                  let val = cell.value

                  if (cell.isHyperlink) val = cell.value.text
                  if (typeof val == "object") {
                    // if (cell.type === ExcelJS.ValueType.Date) val = formatDateString(val)
                    if (cell.type === ExcelJS.ValueType.Formula || cell.type === ExcelJS.ValueType.RichText) val = cell.text
                  }

                  cell.value = rowData[key] = String(val).trim()
                }
              }
            })
            jsonData.push(rowData)
          }
        })

        const buffer = await workbook.xlsx.writeBuffer()

        files = new File([buffer], files.name, {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        console.log(files)
      } catch (error) {
        console.error(error)
        throw "Error parsing the sheet. Please review your sheet and try again, as there may be an issue with its content. If the problem persists, feel free to contact us for assistance."
      }

      if (!jsonData.length) throw "Invalid Spreadsheet"

      jsonData = modifyXlData(jsonData)

      // jsonData = addMetadataFields(documentData.metadata, jsonData)

      // jsonData = addValueToEmptyTitle(jsonData)
      width = 100

      isInvalidCellsFound = Object.keys($bulkUploadOperations.invalidObj).length ? true : false

      if (isInvalidCellsFound) {
        updateLocalStorage($bulkUploadOperations)
        // If invalid cells are found, redirect to the "invalid" page
        push("/publish/bulk/invalid")
      }

      // isUserSelectedUploadFiles = !bulkData.bulk.generateFile

      sessionName = sessionName.slice(27, sessionName.length)
      sessionName = sessionName.replace(/[^A-Z\d\s-()+&.:]/gi, "").trim()

      sessionName = sessionName ? sessionName : documentData.name
      sessionName = sessionName.slice(0, 30)

      session.name = `${sessionName}-${new Date(Date.now()).toISOString().slice(0, 19).replace("T", " ")}`

      // Replace any forward slashes (/) with dashes (-) in the batch name
      session.name = session.name.replaceAll("/", "-")

      // disabling upload button
      showProgress = false
      disableNextBtn = false

      clubDate(jsonData)
    } catch (error) {
      // console.error(error)
      const info = "PAGE: Start Bulk Upload\nEVENT: While validating uploaded spreadsheet"
      notificationInvalidFile = notify.danger(error, info)
      files = undefined
      e.dataTransfer ? (e.dataTransfer.value = null) : (e.target.value = null)
    } finally {
    }
  }

  /**
   * Convert a date string in the format "dd-mm-yyyy" to an ISO string.
   *
   * @param {string} dateString - The input date string in the format "dd-mm-yyyy".
   * @returns {string} The ISO string representation of the input date.
   */
  const convertToISOString = (dateString, type) => {
    // if (!isValidDate(dateString)) return
    // dateString = dateString.toString()
    if (typeof dateString == "object") {
      if (type === ExcelJS.ValueType.Date) {
        dateString = formatDateString(dateString)
      }
    }
    dateString = dateString.toString().trim()

    if (!dateString) return
    if (dateString.includes("/")) dateString = dateString.replaceAll("/", "-")
    if (!dateRegex.test(dateString)) return
    if (!isValidDate(dateString)) return

    // Split the input date string into day, month, and year components
    const dateComponents = dateString.split("-")
    const day = dateComponents[0]
    const month = dateComponents[1]
    const year = dateComponents[2]

    // Convert the Date object to an ISO string and return it

    return new Date(`${year}-${month}-${day}`).toISOString()
  }

  /**
   * Function for storing the details fetched from the file template
   *
   * @param {Object} layers - The file data containing information about the file.
   */
  const processFileData = (layers) => {
    try {
      // Filter layers to get dynamic image layers
      let layerWithDynamicImg = layers.filter((layer) => layer.type == "image" && layer.dynamic)

      // Convert dynamic image layer attributes to capitalized array entries
      layerWithDynamicImg = capitalizeArrayEntries(Array.from(layerWithDynamicImg).map((layer) => layer.attribute))

      // If there are dynamic image layers, return the attribute names
      if (layerWithDynamicImg.length) {
        return [...layerWithDynamicImg]
      } else {
        return []
      }
    } catch (error) {
      throw error
    }
  }

  /**
   * Compares two arrays to check if they are equal in terms of length and element values.
   *
   * @param {Array} row - The first array for comparison.
   * @param {Array} generated - The second array for comparison.
   * @returns {boolean} True if the arrays are equal, otherwise false.
   */
  const areArraysEqual = (row, generated) => {
    // Check if the lengths of the arrays are different
    if (row.length !== generated.length) {
      return false
    }

    // Iterate through the elements of the arrays and compare them
    for (let i = 0; i < row.length; i++) {
      // If any elements at the same index are different, arrays are not equal
      if (row[i] !== generated[i]) {
        return false
      }
    }

    // If all elements are equal, arrays are considered equal
    return true
  }

  /**
   * Function to check if there are duplicate entries of a specific value in an array.
   * @param arr
   * @param value
   */
  const hasDuplicate = (arr, value) => {
    // Use the filter method to create a new array containing only elements that match the specified value.
    const count = arr.filter((item) => item === value).length

    // Check if the count of matching elements is greater than 1, indicating duplicates are present.
    return count > 1
  }

  /**
   * Generates a header array based on given options, including metadata, generation of a file, and email sending.
   * @param {Object} options - Options object containing title, lexpiry
   * @param {boolean} generateFile - Whether a file will be generated.
   * @param {boolean} toSendEmail - Whether an email will be sent.
   * @returns {Array} An array containing header entries for data representation.
   */
  const generateHeader = (options, generateFile, toSendEmail) => {
    // Flatten the metadata object to extract keys
    let flatObject = flatenObject(options.metadata)

    // Extract keys from the flattened object
    let tempKeys = Object.keys(flatObject)

    // Create an array to store keys without corresponding values
    let keys = []

    // Iterate through tempKeys to filter out keys with no values
    for (let i = 0; i < tempKeys.length; i++) {
      if (!flatObject[tempKeys[i]]) {
        keys.push(tempKeys[i])
      }
    }

    // Add fixed keys "Title" and "Expiry"
    // keys = [...keys, "Title", "Expiry"]
    keys = [...keys, "Expiry"]

    // Add layers if available in options
    if (options.layers.length) {
      options.layers = [...new Set(options.layers)]
      keys = [...keys, ...options.layers]
    }

    // Add "Filename" to keys if generateFile is false
    if (!generateFile) {
      keys = ["Filename", ...keys]
    }

    // Add "Email" to keys if toSendEmail is true
    if (toSendEmail) {
      keys = [...keys, "Email"]
    }

    // Capitalize the entries in the keys array
    keys = capitalizeArrayEntries(keys)

    // Return the generated keys array
    return keys
  }

  const modifyXlData = (jsonData) => {
    try {
      /**
       * The array to store the modified data objects with metadata and options properties.
       * @type {Array<Object>}
       */
      let modifiedData = []
      /**
       * The keys of the options
       * @type {Array<String>}
       */
      let optionsArr = ["title", "expireOn", "email", "date"]
      // Loop through the input Excel data array
      for (let i = 0; i < jsonData.length; i++) {
        /**
         * A temporary object to store metadata and options properties for each Excel data object.
         * @type {Object}
         */
        let tempObj = {
          id: "",
          metadata: {},
          options: {},
          files: {},
        }

        // Iterate through the properties of each Excel data object
        for (const [key, value] of Object.entries(jsonData[i])) {
          if (key.includes("_")) tempObj.metadata[key] = value
          else {
            let iskeyFound = optionsArr.filter((option) => option === key)
            if (iskeyFound.length) {
              if (value) {
                tempObj.options[key] = value
              }
            } else {
              tempObj.files[key] = value
            }
          }
        }

        tempObj.metadata = unflattenObject(tempObj.metadata)

        // Add the temporary object to the data array
        modifiedData = [...modifiedData, tempObj]
      }
      return modifiedData
    } catch (error) {
      throw error
    }
  }

  const addMetadataFields = (documentData, jsonData) => {
    try {
      // parsing the stringified metadata
      let parsedJson = JSON.parse(documentData)

      // looping through jsonData for modifying its metadata fields
      for (let i = 0; i < jsonData.length; i++) {
        // assigning flattened parsedJson
        let flatObject = flatenObject(parsedJson)

        // assigning flattened current metadata
        let flatJsonMetadata = flatenObject(jsonData[i].metadata)

        // looping through keys and values of the object
        for (const [key, value] of Object.entries(flatObject)) {
          if (!flatObject[key]) flatObject[key] = flatJsonMetadata[key]
        }

        // unflattened and assigning to jsonData
        jsonData[i].metadata = JSON.parse(JSON.stringify(unflattenObject(flatObject)))
      }

      return jsonData
    } catch (error) {
      throw error
    }
  }

  /**
   * Function to validate if a filename ends with .jpg, .jpeg, or .png
   * @param {string} filename - The filename to be validated
   * @returns {boolean} - True if the filename ends with a valid extension, false otherwise
   */
  const isValidImageFilename = (filename) => {
    // Define a regular expression pattern for valid extensions
    const validExtensionsPattern = /\.(jpg|jpeg|png)$/i

    // Use the test method of the regular expression to check if the filename matches
    return validExtensionsPattern.test(filename)
  }

  /**
   * Adds a default value to the 'title' property in objects where it is empty.
   * @param {Array} jsonData - An array of objects containing metadata and options.
   * @returns {Array} The modified array with empty 'title' properties filled with default values.
   */
  const addValueToEmptyTitle = (jsonData) => {
    // Iterate through each object in the 'jsonData' array
    for (let i = 0; i < jsonData.length; i++) {
      // Check if the 'title' property in the 'options' object is empty

      if (!jsonData[i].options.title) {
        // Assign a default value from the 'document.type' property in the 'metadata' object
        jsonData[i].options.title = jsonData[i].metadata.document.type
      }
    }

    // Return the modified 'jsonData' array
    return jsonData
  }

  /**
   * Converts the first letter of a string to lowercase.
   *
   * @param {string} str - The input string.
   * @returns {string} The input string with the first letter converted to lowercase.
   */
  const firstLetterToLower = (str) => {
    /**
     * Get the first character of the input string and convert it to lowercase
     * Concatenate the lowercased first letter with the rest of the string
     */
    if (str) return str.charAt(0).toLowerCase() + str.slice(1)
    else return null
  }

  /**
   * Function to validate a row based on the provided key
   * @param {Object} cell cell object of the excel file
   * @param {String} key header value of the individual cell
   */
  const validateRowBasedOnKey = (cell, key) => {
    try {
      // Check if the key is one of the specific keys requiring validation
      if (key === "receiver_name" || key === "document_type" || key === "issuer_signatory") {
        // Apply validation for certain keys using validateEachCell function
        validateEachCell(cell, key)
      }
      // Check if the key is "filename"
      else if (key === "filename") {
        // Apply specific validation for filename using validateFileName function
        validateFileName(cell, key)
      }
      // Check if the key is "expiry"
      else if (key === "expiry") {
        // Validate date entry only if cell has a value
        if (cell.value) {
          isExpiryGiven = true
          validateDateEntry(cell, key)
        }
      }
      // Check if the key is "email"
      else if (key === "email") {
        // Apply validation for email entry using validateEmailEntry function
        validateEmailEntry(cell, key)
      }
      // Check if the key is "title"
      else if (key === "title" || key.includes("_")) {
        // Validate cell if it has a value using validateEachCell function
        if (cell.value) {
          validateEachCell(cell, key)
        }
      }
      // For other cases
      else {
        // Validate cell using validateEachCell function
        validateEachCell(cell, key)
      }
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  /**
   * Function to validate a cell if the key matches "email"
   * @param {Object} cell cell object of the excel file
   * @param {String} key header value of the individual cell
   */
  const validateEmailEntry = (cell, key) => {
    try {
      // Extract the value from the cell
      let value = cell.value

      // Array to store error messages
      let errorArr = []

      // Check if the cell contains a hyperlink, and if so, add an error message for invalid format
      if (cell.isHyperlink) {
        value = value.text
      }

      if (typeof value == "object") {
        if (cell.type === ExcelJS.ValueType.RichText) {
          value = cell.text
        } else if (cell.type === ExcelJS.ValueType.Formula) {
          if (typeof cell.value.result == "object") {
            if (Array.isArray(cell.value.result)) {
              errorArr = [...errorArr, "Invalid Cell"]
            } else {
              if (cell.value.result.error) {
                errorArr = [...errorArr, "Invalid Cell"]
              } else {
                value = cell.value.result
              }
            }
          } else {
            value = cell.value.result
          }
        } else {
          errorArr = [...errorArr, "Invalid Format <span class='text-white'>(Format should be General or Text)</span>"]
        }
      }

      value = String(value).trim()

      // Check for empty values with only whitespace and add an error message if found
      if (!value) {
        errorArr = [...errorArr, "Empty value not allowed"]
      } else {
        // Regular expression pattern to validate email addresses
        // const emailAddressPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        // Check if the value matches the email address pattern and add an error message if not
        if (!emailAddressPattern.test(value)) {
          errorArr = [...errorArr, "Invalid Email address"]
        }

        // Regular expression to detect HTML entities in the value
        // const htmlEntityRegex = /&[a-zA-Z]+;/

        // Check if the value contains HTML entities and add an error message if found
        if (htmlEntityRegex.test(value)) {
          errorArr = [...errorArr, "HTML entities not allowed."]
        }
      }

      // If there are any error messages in the array, call a function to add them to an error object
      if (errorArr.length) addEntriesToErrorObj(errorArr, cell, key)
    } catch (error) {
      throw error
    }
  }

  /**
   * Function to validate a cell if the key matches "filename"
   * @param {Object} cell cell object of the excel file
   * @param {String} key header value of the individual cell
   */
  const validateFileName = (cell, key) => {
    try {
      // Extract the value from the cell
      let value = cell.value

      // Array to store validation error messages
      let errorArr = []

      // Check for empty value and add an error message if the value is empty
      if (!value) {
        errorArr = [...errorArr, "Empty value not allowed"]
      } else {
        // Check if the cell contains a hyperlink and add an error message for invalid format
        if (cell.isHyperlink) {
          value = value.text
        }
        if (typeof value == "object") {
          if (cell.type === ExcelJS.ValueType.RichText) {
            value = cell.text
          } else if (cell.type === ExcelJS.ValueType.Formula) {
            if (typeof cell.value.result == "object") {
              if (Array.isArray(cell.value.result)) {
                errorArr = [...errorArr, "Invalid Cell"]
              } else {
                if (cell.value.result.error) {
                  errorArr = [...errorArr, "Invalid Cell"]
                } else {
                  value = cell.value.result
                }
              }
            } else {
              value = cell.value.result
            }
          } else {
            errorArr = [...errorArr, "Invalid Format <span class='text-white'>(Format should be General or Text)</span>"]
          }
        }

        value = String(value).trim()

        // Check for empty values with only whitespace and add an error message if found
        if (!value) {
          errorArr = [...errorArr, "Empty value not allowed"]
        } else {
          if (!isValidImageFilename(value)) {
            errorArr = [...errorArr, "Invalid File Format <span class='text-white'>(.jpg,.jpeg,.png only allowed)</span>"]
          }
          if (hasDuplicate(uploadFileList, value)) {
            errorArr = [...errorArr, "Duplicate Entries Found"]
          }
        }
      }

      // If there are any error messages in the array, call a function to add them to an error object
      if (errorArr.length) {
        addEntriesToErrorObj(errorArr, cell, key)
      }
    } catch (error) {
      throw error
    }
  }

  const formatDateString = (value) => {
    return new Date(value).toISOString().split("T")[0].split("-").reverse().join("-")
  }

  /**
   * Function to validate a cell if the key matches "expiry"
   * @param {Object} cell cell object of the excel file
   * @param {String} key header value of the individual cell
   */
  const validateDateEntry = (cell, key) => {
    try {
      let value = cell.value
      let errorArr = [] // Array to store validation errors

      // (value, typeof value, "date")

      if (cell.isHyperlink) {
        errorArr = [...errorArr, "Invalid Date <span class='text-white'>(Date Format should be General or Text)</span>"]
      } else {
        if (typeof value == "object") {
          if (cell.type === ExcelJS.ValueType.Date) {
            value = formatDateString(value)
          } else if (cell.type === ExcelJS.ValueType.RichText) {
            value = cell.text
          } else if (cell.type === ExcelJS.ValueType.Formula) {
            if (typeof cell.value.result == "object") {
              if (Array.isArray(cell.value.result)) {
                errorArr = [...errorArr, "Invalid Cell"]
              } else {
                if (cell.value.result.error) {
                  errorArr = [...errorArr, "Invalid Cell"]
                } else {
                  value = cell.value.result
                }
              }
            } else {
              value = cell.value.result
            }
          } else {
            errorArr = [...errorArr, "Invalid Format <span class='text-white'>(Format should be General or Text)</span>"]
          }
          // if (value != new Date(value).toISOString()) errorArr.push("Invalid Date (Date Format should be General or Text)")
        }

        value = String(value).trim()

        if (value) {
          if (value.includes("/")) {
            value = value.replaceAll("/", "-")
          }

          if (!dateRegex.test(value)) {
            errorArr = [...errorArr, "Invalid Characters found"] // Add error message for invalid characters in the date
          }

          if (htmlEntityRegex.test(value)) {
            errorArr = [...errorArr, "HTML entities not allowed."] // Add error message for HTML entities in the date
          }

          if (isDateExpired(value)) errorArr = [...errorArr, "Invalid Date Format <span class='text-white'>(Dont choose older Date)</span>"]

          if (!isValidDate(value)) {
            errorArr = [...errorArr, "Invalid Date"]
          }
        }
      }

      // If there are any validation errors for this cell
      if (errorArr.length) addEntriesToErrorObj(errorArr, cell, key)
    } catch (error) {
      console.error(error) // Log any unexpected errors that occur during validation
      throw error
    }
  }

  /**
   * Checks if the provided date string is a valid date in different formats.
   * @param {string} dateString - The date string to validate.
   * @returns {boolean} True if the date string is valid; otherwise, false.
   */
  const isValidDate = (dateString) => {
    const dateFirstFormats = [/^(\d{2})-(\d{2})-(\d{4})$/, /^(\d{2})\/(\d{2})\/(\d{4})$/]

    for (const format of dateFirstFormats) {
      const match = dateString.match(format)
      if (match) {
        const [, ...parts] = match
        const dateObj = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`)
        return !isNaN(dateObj) && dateObj.toISOString().substring(0, 10) === `${parts[2]}-${parts[1]}-${parts[0]}`
      }
    }

    const yearFirstFormats = [/^(\d{4})-(\d{2})-(\d{2})$/, /^(\d{4})\/(\d{2})\/(\d{2})$/]

    for (const format of yearFirstFormats) {
      const match = dateString.match(format)
      if (match) {
        const [, ...parts] = match
        const dateObj = new Date(`${parts[0]}-${parts[1]}-${parts[2]}`)
        return !isNaN(dateObj) && dateObj.toISOString().substring(0, 10) === `${parts[0]}-${parts[1]}-${parts[2]}`
      }
    }

    return false
  }

  /**
   * Checks if a given date is expired.
   * @param {string} value - The date value to be validated.
   * @returns {boolean} True if the date is expired, otherwise false.
   */
  const isDateExpired = (value) => {
    let expirationDate = new Date(parseCustomDate(value))
    let currentDate = new Date()

    // Remove the time component from both dates
    expirationDate.setHours(0, 0, 0, 0)
    currentDate.setHours(0, 0, 0, 0)

    // Compare the dates
    if (expirationDate <= currentDate) {
      return true // Expiration date is in the past
    } else {
      return false // Expiration date is valid
    }
  }

  /**
   * Parses a custom date string into a Date object.
   * @param {string} dateString - The custom date string to parse.
   * @returns {Date} The parsed Date object.
   */
  const parseCustomDate = (dateString) => {
    try {
      // Split the date string into an array using the "-" delimiter
      let parts = dateString.split("-")

      // Extract day, month, and year from the parts array
      const day = parseInt(parts[0])
      const month = parseInt(parts[1])
      const year = parseInt(parts[2])

      // Array of month names
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

      // Format the date string using month name, day, and year
      const formattedDate = `${monthNames[month - 1]} ${day} ${year}`

      // Create a new Date object from the formatted date string
      return new Date(formattedDate)
    } catch (error) {
      throw error
    }
  }

  /**
   * Function for validating the each cell of the excel sheet
   * @param {Object} cell cell object of the excel file
   * @param {String} key header value of the individual cell
   */
  const validateEachCell = (cell, key) => {
    try {
      let value = cell.value

      let errorArr = [] // Array to store validation errors
      if (!value) {
        errorArr = [...errorArr, "Empty value not allowed"] // Add error message for empty values
      } else {
        if (cell.isHyperlink) {
          value = value.text
        }
        if (typeof value == "object") {
          //  if (cell.type === ExcelJS.ValueType.Date) {
          //             value = formatDateString(value)
          //           }

          if (cell.type === ExcelJS.ValueType.Formula) {
            if (typeof cell.value.result == "object") {
              if (Array.isArray(cell.value.result)) {
                errorArr = [...errorArr, "Invalid Cell"]
              } else {
                if (cell.value.result.error) {
                  errorArr = [...errorArr, "Invalid Cell"]
                } else {
                  value = cell.value.result
                }
              }
            } else {
              value = cell.value.result
            }
          } else if (cell.type === ExcelJS.ValueType.RichText) {
            value = cell.text
          } else {
            errorArr = [...errorArr, "Invalid Format <span class='text-white'>(Format should be General or Text)</span>"]
          }
        }

        value = String(value).trim()

        if (!value) {
          errorArr = [...errorArr, "Empty value not allowed"] // Add error message for empty values with only whitespace
        } else {
          if (isDynamic) {
            if (!isValidImageFilename(value)) errorArr = [...errorArr, "Invalid File Format  <span class='text-white'>(.jpg,.jpeg,.png only allowed)</span>"]
          }
          if (value.length > 120) {
            errorArr = [...errorArr, "Value shouldn't be more than 120 characters"] // Add error message for values exceeding 120 characters
          }
          // if (!allowedCharsRegex.test(value)) {
          //   errorArr = [...errorArr, "Only letters, numbers, and special characters -()+&,. are allowed."] // Add error message for disallowed characters
          // }
          if (htmlEntityRegex.test(value)) {
            errorArr = [...errorArr, "HTML entities not allowed."] // Add error message for HTML entities
          }
        }
      }

      // If there are any validation errors for this cell
      if (errorArr.length) addEntriesToErrorObj(errorArr, cell, key)
    } catch (error) {
      throw error
    }
  }

  /**
   * Function for adding the entries representing that the entries are invalid
   * @param {Array} errorArr array of errors for the respective cell
   * @param {Object} cell cell object of the excel file
   * @param {String} key header value of the individual cell
   */
  const addEntriesToErrorObj = (errorArr, cell, key) => {
    // Check if the invalidObj for this row exists in the session
    if (!$bulkUploadOperations.invalidObj[`Row ${cell.row}`]) {
      // If not, create it
      $bulkUploadOperations.invalidObj[`Row ${cell.row}`] = {}
    }
    // Store the errors for this cell in the invalidObj
    $bulkUploadOperations.invalidObj[`Row ${cell.row}`][`${cell.address} - ${key}`] = errorArr
  }

  /**
   * Function for the checking whether the file is in the extension of
   * .xlsx or not using magic number
   * @param {File} file - the file to be validated
   */
  const loadFile = (file) => {
    return new Promise((resolve, reject) => {
      // Create a new instance of FileReader
      const filereader = new FileReader()

      // Define the callback function for when the file is loaded
      filereader.onloadend = (e) => {
        // Extract the first 4 bytes of the file as an Uint8Array
        const arr = new Uint8Array(e.target.result).subarray(0, 4)
        let header = ""

        // Iterate over the bytes and convert them to hexadecimal representation
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16)
        }

        // Check if the header matches the expected value "504b34"
        if (header == "504b34") {
          // If the header matches, resolve the Promise with the file object
          resolve(file)
        } else {
          // If the header doesn't match, reject the Promise with an error message
          reject("Invalid Format")
        }
      }

      // Read the first 4 bytes of the file as an ArrayBuffer
      filereader.readAsArrayBuffer(file.slice(0, 4))
    })
  }

  /**
   * Function for processing or read the excel file
   * @param {File} file - the excel file to be processed
   */
  const processExcel = async (file) => {
    return new Promise((resolve, reject) => {
      // Create a new instance of FileReader
      const filereader = new FileReader()

      // Define the callback function for when the file is loaded
      filereader.onloadend = async (e) => {
        // Create a new instance of ExcelJS Workbook
        const workbook = new ExcelJS.Workbook()

        try {
          // Load the Excel file into the workbook
          await workbook.xlsx.load(e.target.result)

          if (!worksheetName) {
            if (workbook.worksheets.length == 0) throw "The uploaded spreadsheet file does not contain any sheets."

            // Get the name of the worksheet
            worksheetName = workbook.worksheets[0].name

            if (workbook.worksheets.length > 1) reject("Multiple Sheets not allowed")
          }

          // Get the worksheet object by its name
          // let worksheet = workbook.getWorksheet(worksheetName)

          // Resolve the Promise with the worksheet object
          resolve(workbook)
        } catch (error) {
          // Reject the Promise if there is an error loading the Excel file
          reject(error)
        }
      }

      // Read the file as an ArrayBuffer
      filereader.readAsArrayBuffer(file)
    })
  }

  /**
   * Function for uploading the excel spreadsheet
   */
  const uploadFile = async () => {
    try {
      if (session.name.length < 4) return

      disableNextBtn = true
      showLoading = true
      // Check if there are any invalid cells found in the data
      // if (isInvalidCellsFound) {
      //   // If invalid cells are found, redirect to the "invalid" page
      //   push("/publish/bulk/invalid")
      // } else {
      let requestBody = {}

      // Assign session properties to the request body
      if (!session.title) session.title = ""
      requestBody.name = session.name
      requestBody.title = session.title
      if (isEmailFound && ccList.length) {
        const ccEntries = ccList.map((c) => c.email)
        requestBody.cc = ccEntries.join(",")
      }
      // requestBody.documentTemplate = files[0].name.slice(0, 24)
      requestBody.file = files
      // requestBody.documentTemplate = session.document
      // requestBody.generateFile = session.toGenerateFiles
      // requestBody.sendEmail = session.toSendEmail

      // Create a new bulk data session using the 'createNewBulkSessionTest' function

      let bulkData = await createNewBulkSessionTest(requestBody)
      // Get the data from the uploaded Excel file using sendXlFile function
      // let parsedData = await sendXlFile(files[0], bulkData.bulkUpload.id)

      // If the data retrieval was not successful, throw an error
      if (!bulkData.success && bulkData.error) {
        if (bulkData.invalidEntries) {
          // if (typeof bulkData.errorCode == "string") throw bulkData.errorCode
          $bulkUploadOperations.invalidObj = bulkData.invalidEntries
          isInvalidCellsFound = true
          // Update local storage with the updated bulkUploadOperations data
          updateLocalStorage($bulkUploadOperations)
          files = undefined
          // If invalid cells are found, redirect to the "invalid" page
          push("/publish/bulk/invalid")
          return
        } else throw bulkData.errorCode
      }

      let bulkID = bulkData.bulkUpload.id
      isUserSelectedUploadFiles = !bulkData.bulkUpload.generateFile

      // Check if the user has selected to upload files
      if (isUserSelectedUploadFiles) {
        // If uploading files, redirect to the "upload-file" page with the bulk ID
        push(`/publish/bulk/upload-file?id=${bulkID}`)
      } else {
        // If generating files, redirect to the "generate-file" page with the bulk ID
        push(`/publish/bulk/generate-file?id=${bulkID}`)
      }
      // }

      // Update local storage with the updated bulkUploadOperations data
      updateLocalStorage($bulkUploadOperations)
    } catch (error) {
      console.error(error)
      const info = "PAGE: Start Bulk Upload\nEVENT: While creating new bulk session by uploading spreadsheet"
      notify.danger(error, info)
      // files = undefined
    } finally {
      disableNextBtn = false
      showLoading = false
    }
  }

  // let downloadType = "Image"

  /**
   * Function for checking minimum characters
   * @param {String} value value to be validated
   * @param {"Batch Name"|"Title"} name name of the value
   */
  const checkMinCharacters = (value) => {
    if (value.length && value.length < 3) {
      // Close any existing notification for minimum characters
      notificationMinChar.close()

      // Display an information notification indicating the maximum allowed characters for the template name
      const info = "PAGE: Start Bulk Upload\nEVENT: Validating minimum character count for the batch name on input blur"
      notificationMinChar = notify.danger(`Batch Name should be more than 3 characters`, info)
    }
  }

  /**
   * Function for validating empty batch name
   * @param {String} value value to be validated
   */
  const checkEmptySessionName = (value) => {
    // Check if the batch name is empty or contains only whitespace characters
    // disableNextBtn = !value.trim()

    // Close any existing notification for batch name
    notificationName.close()

    // Check if the next button should be disabled based on the batch name
    if (!value.trim()) {
      // Display a danger notification indicating that the batch name should not be empty
      const info = "PAGE: Start Bulk Upload\nEVENT: Validating whether the batch name is empty on input blur"
      notificationName = notify.danger("Batch name shouldn't be empty", info)
    }
    return value
  }

  /**
   * @description - function to check not to exceed max characters
   * @param {String} value value to be validated
   * @param {"Batch Name"|"Title"} name name of the value
   */
  const checkMaxCharacters = (value, type, maxCharacters = 50) => {
    if (value.length > maxCharacters) {
      // Close any existing notification for maximum characters
      notificationMaxChar.close()

      // Truncate the value to the maximum allowed characters
      value = value.slice(0, maxCharacters)

      const info = `PAGE: Start Bulk Upload\nEVENT: Validating maximum character count for the ${type} on input blur/ keypress`
      // Display an information notification indicating the maximum allowed characters for the template name
      notificationMaxChar = notify.info(`${type} should not be more than ${maxCharacters} characters`, info)
    }
    return value
  }

  /**
   * Function for checking special characters
   * @param {String} value validating the value if any special characters found
   */
  const checkSpecialCharsWithoutKeyPress = (value) => {
    // Check if the value contains any characters not allowed by the allowedCharsRegex
    if (!allowedCharsRegex.test(value)) {
      // Close any existing notification for special characters
      notificationSplChar.close()

      // Get the value from value
      let sessionName = value

      // Replace any characters in the value that are not letters, numbers, spaces, hyphens, parentheses, plus signs, ampersands, or periods
      let sanitizedText = sessionName.replace(/[^A-Z\d\s-()+&.:]/gi, "").trim()

      // Check if the sanitized text is different from the original pasted text
      if (sanitizedText !== sessionName) {
        // Display a danger notification indicating that only certain characters are allowed
        const info = `PAGE: Start Bulk Upload\nEVENT: Validating invalid characters for the batch name on input blur`
        notificationSplChar = notify.danger("Only letters, numbers, and special characters -()+&.: are allowed.", info)
      }

      // Update value with the sanitized text
      value = sanitizedText
    }
    return value
  }

  /**
   * function to check for given pattern to batch name
   * @param e - to capture key event
   */
  const checkSpecialCharsName = (e) => {
    // Check if it's a keypress event and the pressed key is not allowed
    if (!allowedCharsRegex.test(e.key)) {
      // Prevent the default keypress behavior if the pressed key is not allowed
      e.preventDefault()
      session.name += e.key
      notificationSplChar.close()
      // Show a danger notification indicating the allowed characters
      const info = `PAGE: Start Bulk Upload\nEVENT: Validating invalid characters for the batch name on input keypress`
      notificationSplChar = notify.danger("Only letters, numbers, and special characters -()+&.: are allowed.", info)
      setTimeout(() => {
        session.name = session.name.slice(0, -1)
      }, 100)
    }
  }

  let expiryDates = []
  const clubDate = (dataArray) => {
    expiryDates = []
    let clubedDate = {}
    let rows = []
    let index = 1
    dataArray.forEach((data) => {
      index++
      if (!data.options.expireOn) data.options.expireOn = ""
      if (!clubedDate[data.options.expireOn]) clubedDate[data.options.expireOn] = []
      clubedDate[data.options.expireOn].push(index)
    })

    let dates = Object.keys(clubedDate)

    dates.forEach((date) => {
      let oldRowValue = clubedDate[date]
      let newRowValue = []
      let findHyphen = false
      for (let i = 0; i < oldRowValue.length; i++) {
        if (i == 0) newRowValue.push(oldRowValue[i])
        if (oldRowValue[i + 1] && oldRowValue[i] + 1 != oldRowValue[i + 1]) {
          findHyphen = false
          if (!newRowValue.includes(oldRowValue[i])) newRowValue.push(oldRowValue[i])
          newRowValue.push(oldRowValue[i + 1])
        } else if (i != oldRowValue.length - 1 && !findHyphen) {
          findHyphen = true
          newRowValue.push("-")
        } else if (i == oldRowValue.length - 1) {
          if (!newRowValue.includes(oldRowValue[i])) newRowValue.push(oldRowValue[i])
        }
      }

      let finalRowValue = []
      for (let i = 0; i < newRowValue.length; i++) {
        let value = newRowValue[i]
        if (newRowValue[i + 1] == "-") {
          value = newRowValue[i] + "-" + newRowValue[i + 2]
          i = i + 2
        }
        finalRowValue.push(value)
      }

      expiryDates.push({ date: date, string: finalRowValue.join(", "), rows: clubedDate[date] })
    })
  }

  const confirmExpiryDate = async () => {
    expiryDates.forEach((json) => {
      for (let i = 0; i < json.rows.length; i++) {
        // console.log(jsonData[json.rows[i] - 2].options.expireOn, json.date)
        jsonData[json.rows[i] - 2].options.expireOn = json.date
      }
    })

    // console.log(jsonData)
    // console.log(files)

    const workBook = await getWorkBookExcel(files)

    let worksheetName = workBook.worksheets[0].name

    // Get the worksheet object by its name
    const worksheet = workBook.getWorksheet(worksheetName)
    try {
      // processing the worksheet and converting it into json
      worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
        const isRowEmpty = row.values.every((cellValue) => cellValue.toString().trim() === null || cellValue.toString().trim() === "")

        if (rowNumber !== 1 && !isRowEmpty) {
          let cellCount = worksheet.getRow(1).cellCount
          let currentRow = worksheet.getRow(rowNumber)
          let currentRowValues = currentRow.values
          currentRowValues.shift()

          let ArrayForFillingEmptySpaces = Array(cellCount).fill("")
          for (let i = 0; i < cellCount; i++) {
            if (currentRowValues[i]) ArrayForFillingEmptySpaces[i] = currentRowValues[i]
          }

          currentRow.values = [...ArrayForFillingEmptySpaces]

          currentRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            const modifiedString = cell.address.replace(/[A-Za-z]\d+/g, (match) => {
              return `${match[0]}1`
            })

            let key = worksheet.getCell(modifiedString).value
            if (key && key.toLowerCase() === "expiry") {
              expiryDates.forEach((json) => {
                // if (json.rows.includes(rowNumber)) cell.value = json.date ? new Date(json.date) : ""
                if (json.rows.includes(rowNumber)) cell.value = json.date ? formatDateString(json.date) : ""
                // if (!showDownloadSpreadSheet) showDownloadSpreadSheet = true
              })
            }
          })
        }
      })
    } catch (error) {
      console.error(error)
      throw "The expiration update process failed."
    }

    // console.log(worksheet)

    // const workbook = new ExcelJS.Workbook()
    // worksheet = workbook.addWorksheet("Sheet1")
    // Generate the Excel file and get its binary data as a buffer.
    const buffer = await workBook.xlsx.writeBuffer()

    files = new File([buffer], files.name, {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })

    // console.log(files)

    // // Create a Blob from the buffer, specifying the MIME type as Excel.
    // let blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })

    // // Create a link element to simulate a click event and download the Excel file.
    // let link = document.createElement("a")
    // link.href = URL.createObjectURL(blob)

    // // Specify the download filename for the Excel file.
    // link.download = files.name
    // link.click()

    showExpiryConfirmationModel = false
    dateConfirmed = true
  }

  /**
   * Function for processing or read the excel file
   * @param {File} file - the excel file to be processed
   */
  const getWorkBookExcel = async (file) => {
    return new Promise((resolve, reject) => {
      // Create a new instance of FileReader
      const filereader = new FileReader()

      // Define the callback function for when the file is loaded
      filereader.onloadend = async (e) => {
        // Create a new instance of ExcelJS Workbook
        const workbook = new ExcelJS.Workbook()

        try {
          // Load the Excel file into the workbook
          await workbook.xlsx.load(e.target.result)

          // Check if there is only one worksheet in the workbook
          resolve(workbook)
        } catch (error) {
          // Reject the Promise if there is an error loading the Excel file
          reject(error)
        }
      }

      // Read the file as an ArrayBuffer
      filereader.readAsArrayBuffer(file)
    })
  }

  /**
   * Function to download an Excel sheet using exceljs library
   */
  const downloadSheet = async () => {
    try {
      console.log(files)

      const workBook = await getWorkBookExcel(files)

      const buffer = await workBook.xlsx.writeBuffer()

      // Create a Blob from the buffer, specifying the MIME type as Excel.
      let blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })

      // Create a link element to simulate a click event and download the Excel file.
      let link = document.createElement("a")
      link.href = URL.createObjectURL(blob)

      // Specify the download filename for the Excel file.
      link.download = files.name
      link.click()
    } catch (error) {
      console.log(error)

      const info = "PAGE: Bulk Session List\nEVENT: While Downloading Bulk Report"
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }
</script>

<svelte:head>
  <title>Bulk Upload</title>
</svelte:head>

{#if showLoading}
  <LoadingScreen msg={"File Uploading"} />
{/if}

{#if showOptionsModal}
  <Options
    bind:ccList
    on:close={() => {
      showOptionsModal = false
    }}
  />
{/if}

{#if showMultipleSheetConfirmation}
  <ConfirmationModal
    title="Confirmation"
    content="The uploaded spreadsheet contains multiple sheets, but our platform supports processing only a sheet named <strong class='text-blue-500'>{worksheetName}</strong>. Kindly confirm to proceed with further processing"
    on:click={() => {
      showMultipleSheetConfirmation = false
      worksheetName = ""
      files = undefined
    }}
    on:confirm={() => {
      showMultipleSheetConfirmation = false
      checkFile()
    }}
  />
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  <div class="flex px-6 pb-12 pt-9">
    <div class="relative mx-auto flex w-full max-w-[920px] flex-col justify-between rounded-md bg-white dark:bg-mdGray">
      <div class="flex h-full w-full select-none flex-col p-6 mobile:p-12 xls:text-justify">
        <div class="flex flex-col justify-between gap-3 md:flex-row md:items-center">
          <div class="w-fit text-2xl font-bold dark:text-white lg:text-5xl">Start Bulk Upload</div>
          {#if !files}
            <div class="flex flex-col gap-3 md:h-[36px] md:flex-row md:items-center">
              <button
                on:click={() => {
                  if (isInvalidCellsFound) isInvalidCellsFound = false

                  $bulkUploadOperations.invalidObj = {}

                  push("/publish/bulk/session")
                  updateLocalStorage($bulkUploadOperations)
                }}
                class="flex h-[36px] w-fit items-center rounded-md bg-green-500 px-3 py-1 text-sm font-normal tracking-wider text-white hover:border-transparent hover:bg-green-600"
              >
                <i class="fa-solid fa-gear" />
                <p>&nbsp;&nbsp;Generate&nbsp;Spreadsheet</p>
              </button>
              <a href="#/documents/bulk?limit=10&page=1&sort=-1&sortBy=date&state=pending" class="flex h-[36px] w-fit items-center gap-1 rounded-md bg-blue-500 px-3 py-1 text-sm font-normal tracking-wider text-white hover:border-transparent hover:bg-blue-600">
                <i class="fa-solid fa-circle-play" />
                <p>&nbsp;Resume</p>
              </a>
            </div>
          {:else if !showProgress && files}
            <button
              disabled={disableNextBtn}
              on:click={() => {
                files = undefined
                disableNextBtn = true
              }}
              class="flex h-[36px] w-fit items-center rounded-md bg-red-500 px-5 py-1 text-sm font-normal tracking-wider text-white hover:border-transparent hover:bg-red-600 disabled:cursor-not-allowed"
            >
              <i class="fa-solid fa-circle-xmark" />
              <span>&nbsp;&nbsp;Cancel</span>
            </button>
          {/if}
        </div>
        <div class="mt-6 w-full">
          <!-- <div class="break-words text-justify text-sm text-gray-500 mobile:text-base">Choose a spreadsheet file for upload.Files with extension .xlsx only allowed . Other file types will not be accepted.If you don't have a spreadsheet file to upload, click the Generate option to proceed.</div> -->
          <div class="break-words text-justify text-sm text-gray-500 mobile:text-base">Effortlessly manage and secure multiple documents with DocChain's Bulk Document Publishing—upload a list from Excel, generate documents, publish, and share with ease. Upload a spreadsheet file (Only .xlsx file supported). Click Generate if you don't have one.</div>
        </div>
        <div class="mt-6 flex h-full flex-col gap-3">
          {#if !files}
            <div class="relative flex h-fit w-full flex-col items-center justify-center gap-3 rounded-md border border-dashed border-gray-500 p-3 py-12 hover:bg-[#f7f7f7] dark:bg-mdGray hover:dark:bg-bodyblack">
              <input type="file" on:input={checkFile} class="absolute inset-0 cursor-pointer opacity-0" accept=".xlsx" />
              <i class="fa-solid fa-cloud-arrow-up fa-xl lg:fa-2xl text-blue-500" />
              <p class="mt-3 text-center text-sm font-medium text-gray-500 mobile:text-base">Drag 'n' Drop spreadsheet here or Click here to select spreadsheet</p>
              <span class="select-none text-center text-xs font-normal text-gray-100 md:text-sm">Maximum Size 2MB</span>
              <p class="text-sm font-light text-blue-500">Supported formats: .xlsx files</p>
            </div>
          {:else if files}
            {#if showProgress}
              <Progress
                content={"Your data is being validated locally. Please wait"}
                {width}
                on:click={() => {
                  files = undefined
                  disableNextBtn = true
                }}
              />
              <!-- <Progress {width} content="Activating Labels" /> -->
            {:else}
              <div class="space-y-6">
                <div class="flex w-full items-center justify-between rounded-md bg-green-500/20 px-6 py-3">
                  <div class="flex flex-col text-gray-500 dark:text-white">
                    <h1 class="break-all text-base font-normal">{files.name}</h1>
                    <div class="flex flex-col items-start gap-3 mobile:flex-row mobile:items-center">
                      <h1 class="text-base font-normal">{fileSize} KB</h1>
                      <span class="hidden text-base font-normal mobile:flex">||</span>
                      <h1 class="break-wprds text-base font-normal text-green-500">Total Documents in Spreadsheet: {jsonData.length}</h1>
                    </div>
                  </div>
                  <div class="hidden text-xl text-green-500 mobile:block">
                    <i class="fa-solid fa-circle-check" />
                  </div>
                </div>
                <div class="flex w-full flex-col items-center mobile:flex-row">
                  <div class="w-full select-none text-base font-medium text-gray-500 after:ml-0.5 after:text-red-500 after:content-['*'] mobile:w-1/2">Enter the Batch Name</div>
                  <input
                    on:blur={(e) => {
                      checkMinCharacters(session.name)
                      session.name = checkEmptySessionName(session.name)
                      session.name = checkMaxCharacters(session.name, "Batch Name")
                      session.name = checkSpecialCharsWithoutKeyPress(session.name)
                    }}
                    on:keypress={() => {
                      session.name = checkMaxCharacters(session.name, "Batch Name")
                    }}
                    on:keypress={(e) => {
                      clearTimeout(timer)
                      timer = setTimeout(checkSpecialCharsName(e), 50)
                    }}
                    bind:value={session.name}
                    required
                    type="text"
                    class="session-input dark:text-white"
                    placeholder="Enter Batch name"
                  />
                </div>
                <div class="flex w-full flex-col items-center mobile:flex-row">
                  <div class="w-full select-none text-base font-medium text-gray-500 mobile:w-1/2">
                    Enter the title for the webpage of the <br />
                    documents (Optional)
                  </div>
                  <input
                    on:blur={(e) => {
                      session.title = checkMaxCharacters(session.title, "Webpage Title", 120)
                    }}
                    on:keypress={() => {
                      session.title = checkMaxCharacters(session.title, "Webpage Title", 120)
                    }}
                    bind:value={session.title}
                    type="text"
                    class="session-input dark:text-white"
                    placeholder="Enter Title (Optional)"
                  />
                </div>
                <!-- {#if isEmailFound}
                  <div class="flex w-full flex-col items-start mobile:flex-row">
                    <div class="w-full select-none text-base font-medium text-gray-500 mobile:w-1/2 pt-2">Cc Email Address (Optional)</div>
                    <div class="w-full mobile:w-1/2 mt-3 mobile:mt-0">
                      <form on:submit|preventDefault|stopPropagation={addCcEmail} class={ccEmailList.length ? "space-y-3" : ""}>
                        <div class="relative flex w-full gap-3">
                          <input bind:value={ccGivenEmail} on:blur={addCcEmail}  placeholder="xxxxxx@yourdomain.com" type="text" name="ccGivenEmail" class="h-[37.6px] w-[calc(100%-80px)] rounded-md border border-[#a0a1a580] bg-transparent px-3 pl-5 pr-8 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm" />
                          <button disabled={!ccGivenEmail} type="submit" class="flex h-[37.6px] w-[80px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300">
                            <i class="fa-solid fa-circle-plus fa-lg" />
                            &nbsp;&nbsp;Add
                          </button>
                        </div>
                        <div class="max-h-[200px] w-full space-y-1 overflow-auto">
                          {#each ccEmailList as email}
                            <div class="flex w-full items-center justify-between truncate rounded-md bg-[#e9e9e9] px-3 py-2 dark:bg-bodyblack dark:text-white">
                              <p class="truncate text-xs sm:text-base">{email}</p>
                              <button
                                on:click|preventDefault={() => {
                                  ccEmailList = ccEmailList.filter((e) => e != email)
                                }}
                                class="text-red-500 hover:text-red-600 active:text-red-400"
                              >
                                <i class="fa-solid fa-circle-xmark" />
                              </button>
                            </div>
                          {/each}
                        </div>
                      </form>
                    </div>
                  </div>
                {/if} -->
                <div class="flex w-full flex-col items-center mobile:flex-row">
                  <div class="w-full select-none text-base font-medium text-gray-500 after:ml-0.5 after:text-red-500 after:content-['*'] mobile:w-1/2">Expiry of the documents</div>
                  <!-- {#if isExpiryGiven} -->
                  <button disabled={dateConfirmed} on:click={() => (showExpiryConfirmationModel = true)} type="button" class="mt-3 flex h-9 w-10/12 items-center justify-center rounded-md mobile:mt-0 {dateConfirmed ? 'bg-green-500 hover:bg-green-600 active:bg-green-500' : 'bg-blue-500 hover:bg-blue-600 active:bg-blue-500'}  px-4 text-sm font-medium text-white hover:text-white focus:outline-none disabled:cursor-not-allowed mobile:w-1/2">{dateConfirmed ? "Expiry Confirmed" : "Expiry Confirmation"}</button>
                  <!-- {:else} -->
                  <!-- <span class="text-base font-bold text-white">No Expiry value for all documents</span> -->
                  <!-- {/if} -->
                </div>

                <div class="flex w-full flex-col items-center mobile:flex-row">
                  <div class="w-full select-none text-base font-medium text-gray-500 after:ml-0.5 after:text-red-500 after:content-['*'] mobile:w-1/2">Metadata of the documents</div>
                  <!-- {#if isExpiryGiven} -->
                  <button disabled={metaConfirmed} on:click={() => (showMetaConfirmationModel = true)} type="button" class="mt-3 flex h-9 w-full items-center justify-center rounded-md mobile:mt-0 {metaConfirmed ? 'bg-green-500 hover:bg-green-600 active:bg-green-500' : 'bg-blue-500 hover:bg-blue-600 active:bg-blue-500'}  px-4 text-sm font-medium text-white hover:text-white focus:outline-none disabled:cursor-not-allowed mobile:w-1/2">{metaConfirmed ? "Metadata Confirmed" : "Metadata Confirmation"}</button>
                  <!-- {:else} -->
                  <!-- <span class="text-base font-bold text-white">No Expiry value for all documents</span> -->
                  <!-- {/if} -->
                </div>
              </div>
              {#if showExpiryConfirmationModel}
                <div class="fixed inset-0 z-30 h-screen w-screen select-none overflow-auto bg-[#f7f7f7]/50 backdrop-blur-md dark:bg-bodyblack/50">
                  <!-- svelte-ignore a11y-click-events-have-key-events -->
                  <!-- svelte-ignore missing-declaration -->
                  <div on:click|self={() => (showExpiryConfirmationModel = false)} class="flex min-h-screen items-center justify-center gap-6 p-6">
                    <div class="h-fit w-full rounded-md bg-white px-6 py-3 shadow-lg dark:bg-mdGray md:w-4/5 xl:w-3/5">
                      <Table list={List} title={"Expiry Confirmation"} bind:showDownloadSpreadSheet bind:jsonData={expiryDates} nameSort={false} search={false} dateSort={false} expiryTable={true} on:confirmDate={confirmExpiryDate} on:closeTable={() => (showExpiryConfirmationModel = false)} />
                    </div>
                  </div>
                </div>
              {/if}
              {#if showMetaConfirmationModel}
                <MetaPreviewModal
                  {jsonData}
                  on:onClose={() => {
                    showMetaConfirmationModel = false
                  }}
                  on:onConfirm={() => {
                    metaConfirmed = true
                    showMetaConfirmationModel = false
                  }}
                />
              {/if}
              {#if showDownloadSpreadSheet}
                <button on:click={downloadSheet} name="tooltip" id="Download Modified Document" tooltip-position="top" type="button" class="mt-6 ml-auto h-9 rounded-md mobile:mt-0 {dateConfirmed ? 'bg-green-500 hover:bg-green-600 active:bg-green-500' : 'bg-blue-500 hover:bg-blue-600 active:bg-blue-500'}  px-4 text-sm font-medium text-white hover:text-white focus:outline-none disabled:cursor-not-allowed mobile:w-1/2">
                  Download Modified SpreadSheet&nbsp;&nbsp;&nbsp;
                  <i class="fa-solid fa-download" />
                </button>
              {/if}
            {/if}
          {/if}
        </div>
      </div>

      <div class="flex w-full items-center justify-between px-6 pb-6 mobile:px-12">
        <button
          class:hidden={!isEmailFound || disableNextBtn || !files}
          on:click={() => {
            showOptionsModal = true
          }}
          type="button"
          class="flex h-9 min-w-fit items-center justify-center rounded-md border border-[#a0a1a580] px-4 text-sm font-medium dark:text-white focus:outline-none"
        >
          <span><i class="fa-solid fa-sliders" /></span>
          <span class="select-none">&nbsp;&nbsp;&nbsp;Options&nbsp;&nbsp;</span>
        </button>
        <button disabled={!dateConfirmed || !session.name || !metaConfirmed} class:hidden={disableNextBtn || !files} on:click={uploadFile} type="button" class="disabled:text-white-200/50 ml-auto flex h-9 min-w-fit items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-4 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-gray-200/50">
          <span><i class="fa-solid fa-upload" /></span>
          <span class="select-none">&nbsp;&nbsp;Confirm&nbsp;and&nbsp;Upload&nbsp;</span>
        </button>
      </div>
    </div>
  </div>

  <Footer />
</div>

<style lang="postcss">
  .session-input {
    @apply mt-3 h-[37.6px] w-full rounded-md border border-[#a0a1a580] bg-transparent pl-5 pr-3 text-left placeholder-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 invalid:focus:ring-red-500 mobile:mt-0  mobile:w-1/2 sm:text-sm;
  }
</style>
